<template>
    <div class="ve-list-page">
        <div style=" background:white;line-height:30px;border-bottom:2px solid #389;height:40px"> 
            <div style="padding-top:3px;display:flex;width:1400px; ">
                <div style="width:70px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" style="margin-top:0px;"><span style="font-size:13px;margin-right:15px;">{{ $LANG('0138', '新增') }} </span></el-link>
                </div>
                <!-- <el-select v-model="stfgSet"  size="small" @change="stfgChange" style="width:110px">
                    <el-option :label="$LANG('0321', '所有')" value="ALL"></el-option>
                    <el-option :label="$LANG('2005', '未审核')" value="N"></el-option>
                    <el-option :label="$LANG('1976', '已审核')" value="Y"></el-option>
                </el-select> -->
                <span style=" margin-left:20px;font-size:12px;margin-right:10px;">{{ $LANG('0681', '字段查询') }}</span>
                <el-select v-model="selparam" size="small" :placeholder="$LANG('1675', '请选择列名')" clearable  style="width:150px; " >
                    <span v-for="item in pkgCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input clearable :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="stfgChange" size="small" style="width:300px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="stfgChange" ></el-button>
                </el-input> 
                <el-select v-model="selparam2" size="small" :placeholder="$LANG('1675', '请选择列名')" clearable  style="width:150px; " >
                    <span v-for="item in pkgCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input clearable :placeholder="input_hold" v-model="txtparam2" @keyup.enter.native="stfgChange" size="small" style="width:300px; height:30px; ">
                    <el-select v-model="oper2" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="stfgChange" ></el-button>
                </el-input>
                <i class="iconfont icon-ziyuan" style="color:#409EFF;font-size:14px;margin:0 5px 0 15px;"></i>
                <el-link @click="openFieldSettingsDialog().catch(() => {})" :underline="false"><span style="font-size:12px;margin-right:15px;">{{ $LANG('0683', '字段设置') }}</span></el-link>
            </div>
        </div>
        <div class="ve-list-page__table">
        <ve-table :columns="vueCol"
                :table-data="pkgData"
                :columnHiddenOption="columnHiddenOption"
                :border-around="true"
                :border-x="true"
                :border-y="true"
                :fixed-header="true"
                row-key-field-name="IDSEQ"
                :row-style-option="rowStyleOption"
                :cell-style-option="cellStyleOption"
                :max-height="subHeight"
                :virtual-scroll-option="virtualScrollOption"
                :scroll-width="0"
                :column-width-resize-option="columnWidthResizeOption"
                :clipboardOption="{copy:true,paste:false,cut:false,delete:false}"
                :cellSelectionOption="{enable: false}"
                ref="refreq"
                v-loading="loading"
                :element-loading-text="$LANG('1959', '加载中')"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 251, 255, 0.8)">
        </ve-table>
        </div>
        <VeColumnConfigDialog
                :visible="fieldSettingDialog.visible"
                :rows="fieldSettingDialog.rows"
                :loading="fieldSettingDialog.loading"
                :error="fieldSettingDialog.error"
                :locked-field-keys="fieldSettingDialog.lockedFieldKeys"
                :drag-group-field="fieldSettingDialog.dragGroupField"
                :language="$store.state.lang"
                @update:visible="fieldSettingDialog.visible = $event"
                @change="updateFieldSettingsDraft"
                @confirm="saveFieldSettingsDialog"
                @reset="resetFieldSettingsDialog"
                @close="closeFieldSettingsDialog"
        />
        <!-- 分页查询 -->
        <div class="ve-list-page__pagination">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">{{ $LANG('0349', '每页') }}</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">{{ $LANG('0398', '跳至') }}</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">{{ $LANG('1660', '页') }}</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <!-- 提示框 -->
        <el-dialog :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">{{ $LANG('1442', '提示') }}</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <div slot="footer">
                <Button type="primary"   @click="promptWin=false" style="margin-right:20px;">{{ $LANG('1638', '确定') }}</Button>
            </div>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="addWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <Form :model="pkgRow" :label-width="120" ref="pkgform"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in pkgCol" :key="index" >
                        <FormItem   :label="item.title"  class="item-width" v-if="item.fhide==='N'" :prop="item.key"  >                  
                            <el-date-picker size="medium" :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="pkgRow[item.key]" clearable value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-select size="medium" filterable v-else-if="item.key==='PCKNO' " v-model="pkgRow[item.key]"   style="width:100%">
                                <span v-for="(item,index) in supArr" :key="index">
                                    <el-option :label="item.SUPNM" :value="item.IDNO"></el-option>
                                </span>
                            </el-select>
                            <el-input-number size="medium" :disabled="saveFlag||item.disabled==='Y'" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="pkgRow[item.key]" style="width:100%" ></el-input-number>   
                            <el-input size="medium" :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="pkgRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>
                <div class="one-toolbar">
                   <span class="spanRow"> {{ $LANG('2055', '装箱明细') }}【
                        <i class="iconfont icon-xinzeng" style="color:white;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                        <el-link :disabled="addBool||saveFlag" @click="dtlAdd" :underline="false" style="color:white"><span style="font-size:13px;margin-right:15px;">{{ $LANG('0095', '新增记录') }}</span></el-link>
                    】</span>
                </div>
                <el-table  :data="dtlData" 
                    border           
                    class="custom-table-border"                 
                    size="small"
                    :height="dtlHeight" 
                    :row-key="getDtlKey"
                    ref="refdtl"
                    style="margin-top:-8px"
                    show-summary
                    :summary-method="getMatSum"
                    :cell-style="{padding:'2px'}"
                    :row-class-name="tabRowClass"
                    cell-class-name="clearPadding"
                    @row-click="getRowClick"
                    highlight-current-row > 
                <el-table-column type="index" width="60" :label="$LANG('0310', '序号')"></el-table-column>
                    <el-table-column  v-for="(item,index ) in dtlCol.filter(item=>item.thide=='N')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.sortable=='N'"
                        :min-width="item.width">
                        <template slot="header"><span v-if="item.notnull=='Y'" style="color:red">{{item.title}}</span></template>
                        <template slot-scope="scope"> 
                            <span v-if ="saveFlag" >
                                <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                <!-- <span v-else-if="item.key=='TAX'" >{{scope.row['TAXNM']}}</span> -->
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                            <span v-else >
                                <el-input type="number" @change="qtyPrc(scope.row,scope.$index,item.key )" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue" @keyup.down.native="nextLine(item.key,'down')" @keyup.up.native="nextLine(item.key,'up')"  :ref="scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter')"  size="mini" v-if="item.edcss=='number'" :controls="false"  v-model="scope.row[item.key]"  > </el-input>   
 
                                <el-select  size="mini" v-else-if="item.key=='MATTY'" v-model="v_matty">
                                    <el-option :label="$LANG('0424', '产成品')" value="PRD"></el-option>
                                    <el-option :label="$LANG('0443', '原材料')" value="MAT"></el-option>
                                    <el-option :label="$LANG('1798', '样板-模具-设计服务')" value="SMP"></el-option>
                                </el-select>
 
                                <el-input readonly @focus="inputBtn(scope.row,scope.$index,item.key)" :ref="scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter' )" @keyup.down.native="nextLine(item.key,'down' )" @keyup.up.native="nextLine(item.key,'up' )" v-else-if="item.edcss=='button'" size="mini" v-model="scope.row[item.key]"  > </el-input>     
                                <el-date-picker v-else-if="item.edcss=='date'" :clearable="false" value-format="yyyy-MM-dd" type="date" :ref="scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter' )" @keyup.down.native="nextLine(item.key,'down' )" @keyup.up.native="nextLine(item.key,'up' )"  size="mini" v-model="scope.row[item.key]"   > </el-date-picker>     
                                <el-input  v-else-if="item.disabled=='N'"  :ref="scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter' )" @keyup.down.native="nextLine(item.key,'down' )" @keyup.up.native="nextLine(item.key,'up' )" size="mini" v-model="scope.row[item.key]"  > </el-input>                                      
                                <span v-else v-text="scope.row[item.key]"></span>
                            </span>
                        </template>
                    </el-table-column>                
                    <el-table-column
                        fixed="right"
                    :label="$LANG('0330', '操作')"
                        align="center"
                        width="90">
                        <template slot-scope="scope">
                            <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                            <el-link :disabled="saveFlag" @click="dtlDel(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:5px;">{{ $LANG('0131', '删除') }}</span></el-link>
 
                        </template>
                    </el-table-column>  
                </el-table>
 
            </div>
            <div style="height:40px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">
                    <span style="margin-right:25px">
                        <i class="web-font" style="font-size:14px;margin-right:20px;color:#ed4014;font-weight:600"> {{ $LANG('1497', '提示：订单审核后不能再编辑 , 如需编辑请弃审') }}</i>
                        <i v-if="pkgRow['STFG']==='N'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-weishenhe3"> </i>
                        <i v-else-if="pkgRow['STFG']==='Y'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yishenhe1"> </i>
                        <i v-else-if="pkgRow['STFG']==='X'" style="margin-left:20px; color:red;font-size:28px; " class="iconfont icon-yizuofei"> </i>
                    </span>
                    <el-button type="info" size="small" icon="iconfont icon-shanchu"  @click="addWin=false" style="margin-right:25px;">{{ $LANG('0132', '取消') }}</el-button>
                    <el-button :disabled="addBool||saveFlag" type="primary" size="small" icon="iconfont icon-baocun"  @click="saveRec" style="margin-right:10px;">{{ $LANG('0130', '保存') }}</el-button>
                </span>
            </div>
        </el-dialog>
 
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0063', '报表预览') }}</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0059', '报表参数') }}</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog> 
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="selWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">{{ $LANG('0997', '选择记录') }}</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import repWin from '../datamgt/repWin.vue'  
import pubWin from '../datamgt/pubwin.vue'  
import createVeTableFieldSettingMixin from '@/utils/veTableFieldSettingMixin'
import VeColumnConfigDialog from '@/components/VeTable/VeColumnConfigDialog.vue'
import VeTableQueryHeader from '@/components/VeTable/VeTableQueryHeader.vue'
import { buildVeTableFieldCondition, buildVeTableHeaderCondition, isVeTableMetadataField } from '@/utils/veTableHeaderQuery'
export default {
    name:'packing_list',
    mixins: [
        createVeTableFieldSettingMixin({
            settingFormId: '228820',
            fieldIdseq: '228820',
            fieldLstseq: '1',
            mainColumnKey: 'pkgCol',
            tableColumnKey: 'vueCol',
            initColumnKey: 'initCol',
            tableRef: 'refreq',
            generatedFixedColumnKeys: ['rownum', 'index', 'oper'],
        })
    ],
    data () {
        return {
            prodCol:[],

            toolFlag:false,
            qryCond:'',
            oper2:'like',
            dtlRow:{},
            ordWin:false,
            v_matty:'PRD',
            selparam2:'',
            txtparam2:'',
            selPrdWin:false,
            supArr:[],
            promptWin:false,
            dtlFlag:'create',
            prdRow:{},
            supFlag:'',
            addFlag:'create',
            btnWin:false,
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            v_key:'',
            rowDtl:{},
 
            stfgSet:'ALL',
            delDtlArr:[],
            prompt:'',
            input_hold:this.$LANG('1670', '请输入内容...'),
            ruleValidate:{},
            repWin:false,
            repUrl:'',
            selparam:'IDNO',
            txtparam:'',
            pkgRow:{},
            prdFlag:'create',
            goPage:'',
            rowIdseq:'',
            pkgData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            cancelBool:false, //作废权限
            loading:false,
            current:1,
            saveFlag:false,
            allList:[], //询价单集合
            dtlData:[],
            v_formurl:'xuper_auth/getTableRecMany',
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany' , //api请求路径   
            pageList: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
            }],
            dataCount:0,
            rowSize:50,
            dtlCol:[],
            matCol:[],
            pkgCol:[],
            initCol:[],
            vueCol:[],
            columnHiddenOption: {
                defaultHiddenColumnKeys: [],
            },
            rowStyleOption: { clickHighlight: true },
            cellStyleOption: {
                headerCellClass: () => 'table-head-cell-class',
                bodyCellClass: () => 'table-body-cell-class1',
            },
            virtualScrollOption: { enable: false },
            operArr:[],
            prcCol:[],
            prcData:[],
            prdIndex:'',
            oper:'like',
            repDlg:false,
            v_idno:'',
            v_replist:[],
            v_tabIndex:'',
            dtlIndex:'',
            matArr:[],
            comboArr:[],
            repArr:[],
            chkIndex:'',
            skuCol:[],
            v_commit :true,
            stfgBool:true,
            notNull:[],
            qcCol:[],
            v_row:{},
            headerSortKey:'',
            headerSortOrder:'',
            queryRequestId:0,
        }
    },
    components: {
        repWin,
        pubWin,
        VeColumnConfigDialog,
        // JSX query headers are resolved at runtime.
        // eslint-disable-next-line vue/no-unused-components
        VeTableQueryHeader,
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 162) + 'px';
        }, 
        dtlHeight: function() {
            return (window.innerHeight - 310) + 'px';
        }, 
        tabWidth: function() {
            return (window.innerWidth - 100) + 'px';
        }, 
        selWidth: function() {
            return (window.innerWidth - 220) + 'px';
        },
    },
    mounted () {
        getBaseData(this.v_formurl+'','userno',this.v_username,'frmidseq','228820','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        })
 
        getBaseData(this.v_url,'supty','230311','CORPID',this.v_corpid,'V_BS_sup','').then(res=>{
            this.supArr =res.result
        })
 
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','228820','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })    
         //动态生成表单验证规则
        getTabColOrData(this.v_formurl,'v_sys_form_fld','idseq','228820','','','NOTNULL','Y', ' and lstseq in (1 )').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+this.$LANG('2051', '不能为空'),trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        });
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.stfgChange() //装箱单主数据   
            this.comSelect() 
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {

        btnSure(obj){
            if (this.v_key =='MATNO'){
                this.dtlData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{MATNO:obj['IDNO'],MATNM:obj['MATNM'],MATDESC:obj['MATDESC'],BOXL:obj['BOXL'],
                                    BOXW:obj['BOXW'],BOXH:obj['BOXH'],PCS:obj['PCS'],NETWT:obj['NETWT'],GROSSWT:obj['GROSSWT']} ))
                this.$refs[ this.v_tabIndex+'QTY'][0].focus()  
                this.chkIndex =this.v_tabIndex
            }else if (this.v_key =='SKUNO'){
                this.dtlData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{SKUNO:obj['SKU']} ))
                this.chkIndex =this.v_tabIndex
            }else if (this.v_key =='QCNO'){
                this.dtlData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{QCNO:obj['IDNO']} ))
                this.chkIndex =this.v_tabIndex
            }
            this.btnWin =false
        },
        inputBtn( row, index, key){
            this.v_key =key    
            if (key =='MATNO'){ //物料
                this.v_tabRow =row
                this.v_tabIndex =index
                this.v_table ='v_bs_mat'
                this.tableCol =this.prodCol
                this.v_key2 ='modelno'
                this.v_value2 =this.v_matty//row['MATTY']
            }else if (key =='SKUNO'){ //SKU
                this.v_tabRow =row
                this.v_tabIndex =index
                this.v_table ='V_AMZ_MAT_SKU'
                this.tableCol =this.skuCol
                this.v_key2 ='matno'
                this.v_value2 =row['MATNO']
            }else if (key =='QCNO'){ //成品检验单
                this.v_tabRow =row
                this.v_tabIndex =index
                this.v_table ='V_QC_PRD'
                this.tableCol =this.qcCol
                this.v_key2 ='prdno'
                this.v_value2 =row['MATNO']
            }  
            this.btnWin =true
        },
        //表格行 按回车键 到下一行
        nextLine(key,val ){ 
            if (val =='enter'){
                if (key =='RMK'){
                    this.chkIndex = this.chkIndex +1
                    let v_count=''
                    v_count =this.dtlData.length                 
                    if (this.chkIndex >=v_count) {
                        this.chkIndex =0
                    }
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                    this.$refs[ this.chkIndex+'QTY'][0].focus()  
                }else{
                    let v_col = this.dtlCol.filter(item=>item.thide=='N'&&item.disabled=='N'&&item.edcss!=='checkbox'&&item.key!=='SKUNO')
                    v_col.some((item,index)=>{
                        if (item.key==key){
                            this.$refs[ this.chkIndex+ v_col[index+1].key][0].focus()  
                        }
                    })
                } 
            }else if (val =='down'){
                this.chkIndex = this.chkIndex +1       
                if (this.chkIndex >=this.dtlData.length) {
                    this.chkIndex =0
                }
                this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])           
                this.$refs[this.chkIndex+key][0].focus()             
            }else if (val =='up'){
                this.chkIndex = this.chkIndex -1
                if (this.chkIndex <=0) {
                    this.chkIndex =0
                }                            
                this.$refs[ this.chkIndex+key][0].focus()  
                this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])       
            }                    
        },
        getRowClick(row){
            this.chkIndex =row.index
        },
 
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        getMatSum(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]=this.$LANG('0280', '合计')
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if(column.property==='QTY'||column.property==='TTLPCS'||column.property==='TTLCUBE'||column.property==='TTLNET'||column.property==='TTLGROSS' ){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(2) 
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
 
        //值改变时计算
        qtyPrc(row,index,key){  
            //总箱数 
            if ( row['PCS'] && row['QTY'] ){ 
                row['TTLPCS']=Math.ceil(Number(row['QTY'])/Number(row['PCS'])) // 
            }
            //单箱体积
            if ( row['BOXL'] && row['BOXW']&& row['BOXH'] ){ 
                row['PCSCUBE']= (Number(row['BOXL'])*Number(row['BOXW'])*Number(row['BOXH'])/1000000).toFixed(4) // 
            }
            //总体积
            if ( row['BOXL'] && row['BOXW']&& row['BOXH']&& row['PCS'] && row['TTLPCS']){ 
                row['TTLCUBE']= (Number(row['BOXL'])*Number(row['BOXW'])*Number(row['BOXH'])/1000000*Number(row['QTY'])/Number(row['PCS'])).toFixed(4) // 
            }
            //总净重
            if ( row['NETWT']  &&row['PCS'] && row['QTY']){ 
                row['TTLNET']= (Number(row['NETWT'])  *Number(row['QTY'])/Number(row['PCS'])).toFixed(2) // 
            }
            //总毛重
            if ( row['GROSSWT']  &&row['PCS'] && row['QTY']){ 
                row['TTLGROSS']= (Number(row['GROSSWT'])  *Number(row['QTY'])/Number(row['PCS'])).toFixed(2) // 
            }
        },

        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld',p_key:'idseq',p_value:'228820',p_cond:' and lstseq in (1,2)',p_key2:'edcss',p_value2:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            })  
        },
        //明细编辑、删除
        dtlDel(row,index){
            this.delDtlArr.push(row)
            this.dtlData.splice(index,1 )
        },
        dtlAdd(){
            let v_row ={}
            this.dtlCol.forEach(item=>{
                v_row[item.key] =''
            })
            v_row['MATTY'] ='PRD'
            this.dtlData.push(v_row)
            this.$nextTick(()=>{
                this.$refs['refdtl'].doLayout()
            }) 
            this.delDtlArr=[]
        },
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
            }else{
                if (row.STFG==='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }   
            }
            this.addFlag='edit'
            this.pkgRow =JSON.parse(JSON.stringify(Object.assign(row,{IDSEQ:row.IDSEQ})))
            this.rowIdseq=row.IDSEQ
            this.getMatList(row['IDSEQ'])
            this.addWin=true      
            this.v_commit =true  
        },
        //保存记录
        saveRec(){
            //发起保存请求   
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.pkgRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                        this.prompt=item.FLDNM+this.$LANG('2051', '不能为空')
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool &&this.v_commit){        
                let v_qty =0,v_pcs=0,v_cube=0,v_net=0,v_gross=0 ,v_title='' 
                this.dtlData.forEach(item => {
                    v_qty =Number(v_qty)+Number(item['TTLPCS'])
                    v_pcs =Number(v_pcs)+Number(item['QTY'])
                    v_cube =Number(v_cube)+Number(item['TTLCUBE'])
                    v_net =Number(v_net)+Number(item['TTLNET'])
                    v_gross =Number(v_gross)+Number(item['TTLGROSS'])
                    this.dtlCol.filter(item =>item.notnull=='Y').some(it =>{
                        if (!item[it.key]){
                            v_title =it['title']
                            return true
                        }
                    }) 
                }) 
                if (v_title){
                    this.promptWin =true
                    this.prompt =v_title +this.$LANG('2051', '不能为空')
                }else{
                    this.v_commit =false
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(Object.assign(this.pkgRow,{CORPID:this.v_corpid,TTLPCS:v_qty,QTY:v_pcs,TTLCUBE:v_cube,TTLNET:v_net,TTLGROSS:v_gross })), p_table:'ord_pack',frmid:'228820'},
                    }).then(res=>{      
                        if(res.result ==='OK')  {  
                            let idseq_ =res.idseq
                            //1、装箱明细保存：批量保存   
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.dtlData), p_table:'ord_packDTL',p_idseq:idseq_ , p_action:'S' },
                            }).then(res=>{
                                if (res.code!=='200'){
                                    this.promtWin=true
                                    this.prompt=res.result
                                }
                            })
                            //退货明细删除
                            for (let k=0;k<this.delDtlArr.length;k++) {
                                this.$axios({   
                                    method: 'post',
                                    url:'xuper_auth/delTabRec',
                                    data: {p_key:'idseq',p_value:idseq_,p_key2:'lstseq',p_value2:this.delDtlArr[k].LSTSEQ, p_table:'ord_packdtl', p_action:'D' },
                                })
                            }         
                            this.addWin =false   
                            this.stfgChange()
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    }) 
                }
            }
        },
        //新增
        addRec(){
            this.addWin=true
            this.pkgRow={DTTM:getDate('day'),'IDSEQ':'',STFG:'N'}
            this.dtlData=[]
            this.saveFlag=false
            this.$nextTick(()=>{
                this.$refs['refdtl'].doLayout()
            })
            this.v_commit =true 
        },
        //表行记录css
        tableRowClass({row, rowIndex}) {
            if (row.STFG  === 'Y') {
                return 'success-row';
            } else if (row.STFG ==='X') {
                return 'cancel-row';
            }
            return '';
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
            return row.index
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt =this.$LANG('1678', '请选择报表')
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO'] 
            }
        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        //状态变更
        stfgRec(row,val,index){
            let v_comm=''
            if (val==='Y'){
                v_comm=this.$LANG('0134', '审核')
            }else if (val==='N'){
                v_comm=this.$LANG('2005', '未审核')
            }else if (val==='X'){
                v_comm=this.$LANG('0257', '作废')
            }
            this.$confirm(this.$LANG('1564', '你确定要')+v_comm+this.$LANG('1565', '此单据吗?'),this.$LANG('1442', '提示'),{
                confirmButtonText: this.$LANG('1638', '确定'),
                cancelButtonText:this.$LANG('0132', '取消'),
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'ord_pack',p_cond:' set stfg=\''+val+'\' '},
                }).then(res=>{      
                    if(res.code =='200')  {    
                        if (val =='X'){
                            this.pkgData.splice(index,1)
                        }else{       
                            Object.assign(row,{STFGNM:v_comm ,STFG:val})
                        }
                    }else{
                        this.prompt=res.result
                        this.promptWin =true
                    }        
                })
            }).catch(()=>{})
             
        },
 
 
        //状态查询
        stfgChange(){
            const firstCondition =this.oper === '!=' && isVeTableMetadataField(this.initCol, this.selparam)
                ? ` and ${this.selparam} is null `
                : buildVeTableFieldCondition(this.initCol, this.selparam, this.txtparam, this.oper)
            const secondCondition =buildVeTableFieldCondition(this.initCol, this.selparam2, this.txtparam2, this.oper2)
            const headerCondition =buildVeTableHeaderCondition(this.initCol, this.v_row, { numberOperatorDefault: '>=' })
            let cond_ =firstCondition+secondCondition+headerCondition
            if (this.stfgSet!=='ALL'){
               cond_=cond_+' and stfg=\''+this.stfgSet+'\''
            }
            this.current =1
            this.getPkgList(cond_)
        }, 
        rowShow(){
            this.v_row ={}
            this.current =1
            this.stfgChange()
        },
        sortHeaderColumn(column){
            const key =column && column.key
            if (!key || !isVeTableMetadataField(this.initCol, key)) return
            if (this.headerSortKey === key) this.headerSortOrder =this.headerSortOrder === 'asc' ? 'desc' : 'asc'
            else {
                this.headerSortKey =key
                this.headerSortOrder ='asc'
            }
            this.stfgChange()
        },
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert(this.$LANG('1721', '请输入跳至页数'), this.$LANG('1442', '提示'), {
                    confirmButtonText: this.$LANG('1638', '确定'),
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.pkgData = this.allList.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            //产品明细
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.pkgData = this.allList          
            }else{
   
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.pkgData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }
            this.$nextTick(() => { //有固定列时 查询后重新布局
                const table = this.$refs.refreq
                if (table && typeof table.doLayout === 'function') table.doLayout()
            }) 
        },
 
        //装箱单 
        getPkgList(cond){
            const requestId =++this.queryRequestId
            this.loading =true
            const orderField =isVeTableMetadataField(this.initCol, this.headerSortKey) ? this.headerSortKey : 'DTTM'
            const orderDirection =this.headerSortKey ? this.headerSortOrder : 'desc'
            getTabColOrData(this.v_formurl,'v_ord_pack','','','CORPID',this.v_corpid,'','',`${cond} order by ${orderField} ${orderDirection}`).then((res) => {
                if (requestId !== this.queryRequestId) return
                if (res.code=='200'){
                    this.allList =res.result || []
                    this.initPage() 
                }else{
                    this.promptWin =true
                    this.prompt =res.result
                }
            }).catch(error=>{
                if (requestId !== this.queryRequestId) return
                this.prompt =error.message || this.$LANG('1641', '查询失败')
                this.promptWin =true
            }).finally(()=>{
                if (requestId === this.queryRequestId) this.loading =false
            })
        },
 
        //装箱明细
        getMatList(idseq){
            this.dtlData =[]
            getTabColOrData(this.v_formurl,'v_ORD_PACKDTL','idseq',idseq,'','','','','' ).then((res) => { 
                this.dtlData =res.result 
                this.$nextTick(()=>{
                    this.$refs['refdtl'].doLayout()
                })
                
            })
        },
        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(vm.v_formurl,'v_sys_form_fld','idseq','228820','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                vm.initCol = res.result || []
                return vm.loadInitialFieldSettings().then(() => {
                    const fieldRows = vm.sortFieldRows(vm.initCol)
                    vm.pkgCol = []
                    vm.vueCol = []
                    fieldRows.forEach(item => {
                        vm.pkgCol.push({
                            title: vm.$translate.getColTitle(item, vm.$store.state.lang),
                            key: item.key,
                            align: item.align,
                            width: item.width,
                            thide: item.THIDE,
                            fhide: item.FHIDE,
                            edcss: item.EDCSS,
                            disabled: item.DISABLED,
                            dotnum: item.DOTNUM,
                            sortable: item.SORTABLE,
                        })
                        if (item.THIDE !== 'N') return
                        const column = item
                        vm.vueCol.push({
                            field: column.key,
                            key: column.key,
                            title: vm.$translate.getColTitle(column, vm.$store.state.lang),
                            type: column.EDCSS === 'checkbox' ? 'check' : column.EDCSS,
                            align: column.align,
                            width: Number(column.width) || 120,
                            sortable: false,
                            ellipsis: { showTitle: true },
                            renderHeaderCell: ({column: veColumn}) => <VeTableQueryHeader
                                title={veColumn.title}
                                edcss={column.EDCSS}
                                value={this.v_row[column.key]}
                                operator={this.v_row[`#OPER${column.key}`]}
                                defaultOperator=">="
                                showDateOperator={false}
                                sortable={column.key !== 'RN' && column.SORTABLE === 'N' && column.EDCSS !== 'checkbox'}
                                sortOrder={this.headerSortKey === column.key ? this.headerSortOrder : ''}
                                options={['select', 'checkbox'].includes(String(column.EDCSS || '').toLowerCase()) ? (this.comboArr[column.key] || []) : []}
                                on-input={(value) => this.$set(this.v_row, column.key, value)}
                                on-operator-change={(value) => this.$set(this.v_row, `#OPER${column.key}`, value)}
                                on-title-click={() => this.sortHeaderColumn(veColumn)}
                                on-query={this.stfgChange}
                            />,
                            renderBodyCell: ({row}) => {
                                const value = row[column.key]
                                if (column.key === 'IDNO') {
                                    return <el-link underline={false} on-click={() => vm.repBtn(row)}><div style="color:#409eff;border-bottom:1px solid red;width:100%;text-align:left;font-size:11px">{value}</div></el-link>
                                }
                                if (column.EDCSS === 'checkbox') {
                                    return <el-checkbox disabled true-label="Y" false-label="N" v-model={row[column.key]}></el-checkbox>
                                }
                                return <div style="float:left">{value}</div>
                            },
                        })
                    })
                    vm.vueCol.unshift({
                        field: 'index',
                        key: 'rownum',
                        title: vm.$LANG('0310', '序号'),
                        width: 60,
                        align: 'center',
                        fixed: 'left',
                        disableResizing: true,
                        renderBodyCell: ({rowIndex}) => rowIndex + 1,
                        renderHeaderCell: ({column}) => <div class="pack-list-sequence-header"><div class="pack-list-sequence-header__title">{column.title}</div><el-link on-click={vm.rowShow} style="font-size:12px;color:#404eff;height:30px"><el-tooltip content={vm.$LANG('0852', '清除条件')} effect="light"><i class="iconfont icon-shanchu1"></i></el-tooltip></el-link></div>,
                    })
                    vm.vueCol.push({
                        field: 'oper0',
                        key: 'oper',
                        title: vm.$LANG('0330', '状态操作'),
                        width: 240,
                        align: 'center',
                        fixed: 'right',
                        disableResizing: true,
                        renderBodyCell: ({row, rowIndex}) => (
                            <div>
                                <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                                <el-link on-click={() => vm.editRec(row, 'Y')} underline={false}><span style="font-size:11px;margin-right:6px">{vm.$LANG('0139', '查看')}</span></el-link>
                                {row.STFG === 'N' ? <span><i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i><el-link disabled={vm.editBool} on-click={() => vm.editRec(row, 'N')} underline={false}><span style="font-size:11px;margin-right:6px">{vm.$LANG('1639', '编辑')}</span></el-link></span> : null}
                                {row.STFG === 'N' ? <span><i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i><el-link disabled={vm.cfmBool} on-click={() => vm.stfgRec(row, 'Y', rowIndex)} underline={false}><span style="font-size:11px;margin-right:6px">{vm.$LANG('1640', '审核')}</span></el-link></span> : null}
                                {row.STFG === 'Y' ? <span><i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i><el-link disabled={vm.cfmBool} on-click={() => vm.stfgRec(row, 'N', rowIndex)} underline={false}><span style="font-size:11px;margin-right:6px">{vm.$LANG('0137', '弃审')}</span></el-link></span> : null}
                                {row.STFG === 'N' ? <span><i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i><el-link disabled={vm.cfmBool} on-click={() => vm.stfgRec(row, 'X', rowIndex)} underline={false}><span style="font-size:11px">{vm.$LANG('0131', '作废')}</span></el-link></span> : null}
                            </div>
                        ),
                    })
                    vm.applyFieldSettingRows()
                })
            })
            getTabColOrData(vm.v_formurl,'v_sys_form_fld','idseq','228820','lstseq','2','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE, 
                        notnull:res.result[k].NOTNULL, 
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.prodCol.push({ //向数组的开头 添加序列号
                      title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                      key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','17354','lstseq','2','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.skuCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss: res.result[k].EDCSS,
                        thide:res.result[k].THIDE,
                        dotnum:res.result[k].DOTNUM,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','412736','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.qcCol.push({ //向数组的开头 添加序列号
                        title: vm.$translate.getColTitle(res.result[k], vm.$store.state.lang),
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                        holder:res.result[k].HOLDER,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .ve-list-page {
        display: flex;
        flex-direction: column;
        height: calc(100% - 32px);
        min-height: 0;
        overflow: hidden;
        background: white;
    }
    .ve-list-page__table {
        flex: 1 1 auto;
        min-height: 0;
        overflow: hidden;
    }
    .ve-list-page__table > .vue-table-root {
        height: 100%;
    }
    .ve-list-page__table /deep/ .ve-table,
    .ve-list-page__table /deep/ .ve-table-container {
        height: 100% !important;
        max-height: 100% !important;
    }
    .ve-list-page__pagination {
        flex: 0 0 38px;
        min-height: 38px;
        overflow: hidden;
        display: flex;
        align-items: flex-start;
        background: white;
        font-size: 12px;
        padding-top: 3px;
        box-sizing: border-box;
    }

    .item-width  {
        width: 32%;
        color:#409EFF;
    }
    .item-width2  {
        width: 48%;
        color:#409EFF;
    }
    .item-row {
        width: 97%;
        color:#409EFF;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .success-row {
        color:#959997;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
